export default "__VITE_ASSET__C7se2Irv__"